import React from "react";
import { useOutletContext } from "react-router-dom";
import { KeyValue, Note, PageHead, Panel, RailCard, DeskSupport } from "@/components/portal/crm/kit";
import { NotifyPrefs } from "@/components/portal/NotifyPrefs";
import { CapacityCard } from "@/components/hub/CapacityCard";
import { AdminPreviewBanner } from "@/pages/introducer/Portal";

export default function Settings() {
  const { me, isAdmin } = useOutletContext();

  return (
    <>
      {isAdmin && <AdminPreviewBanner what="lender desk" />}

      <PageHead
        eyebrow="How we reach you"
        title="Desk settings"
        lede="What reaches you when a case moves, and how much work your desk wants at a time."
        testId="lender-settings-head"
      />

      <div className="grid items-start gap-7 xl:grid-cols-[minmax(0,1fr)_320px]">
        <div className="min-w-0 space-y-7">
          {!isAdmin && <NotifyPrefs />}
          <CapacityCard scope="lender" />

          <Panel title="The 5pm round-up" sub="One email a weekday with what is waiting on your decision, what you are reading, the offers you have out and any notes." testId="lender-settings-brief">
            <ul className="space-y-3 text-[13px] leading-relaxed text-slate-600">
              {[
                "Sent at 5pm UK, Monday to Friday (Monday's covers the weekend), and only when something is actually waiting or has moved.",
                "New cases and your client's documents still reach you straight away; everything else waits for this.",
                "A case you have already passed on, or one that has completed, drops off it.",
                "It replaced the old automatic chase — we would rather send one list than nag you four times.",
                "Switch it off above under Weekly and monthly summaries if you would rather work from the portal alone.",
              ].map((x) => <li key={x} className="flex gap-2.5"><span className="mt-[7px] size-1.5 shrink-0 rounded-full bg-[#0055FF]" />{x}</li>)}
            </ul>
          </Panel>
        </div>

        <div className="space-y-4">
          <RailCard title="Your desk" testId="lender-settings-desk">
            <KeyValue label="Status" value={me?.leads_paused ? "Paused" : (me?.status || "active").replace(/^\w/, (c) => c.toUpperCase())} tone={me?.leads_paused ? undefined : "green"} />
            <KeyValue label="Cap" value={me?.cap_period ? `${me.cap_count} per ${me.cap_period}` : "Uncapped"} />
            <KeyValue label="Turnaround" value={me?.turnaround_days ? `${me.turnaround_days} days` : "Not set"} />
            <KeyValue label="Delivery" value={(me?.delivery_method || "dashboard").replace(/_/g, " ")} />
          </RailCard>

          <DeskSupport body="Going quiet for a fortnight? Pause the desk rather than letting cases sit — the introducer sees the delay, not the reason." />
          <Note>Contracts and new cases always reach you by email. Everything else is your choice.</Note>
        </div>
      </div>
    </>
  );
}
